module.exports = __webpack_public_path__ + "img/record_3.f2f9f1ec.png";